import React, { useEffect, useState } from "react";
import { Checkbox, Button, TextAreaInput } from "../inputs";
import { OverlayTrigger, Popover } from "react-bootstrap";

import {
  OnboardingAxios,
  UserActivityAxios,
  ProgramSetupAxios,
} from "../../API";
import { useDispatch, useSelector } from "react-redux";
import appStateSlice from "../../store/appState/appStateSlice";
import { useHistory } from "react-router";
//import { useLocation } from "react-router-dom";
import Toaster from "./Toast";
import Select from "react-select";
import FeedbackComplete from "../../assets/images/feedbackcomplete.png";
import SkillTrajectory from "../../pages/onboarding/skillTrajectory";
import CdxModal from "../modal/CdxModal";

const EventItem = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showAtendace, setShowAtendace] = useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [isFeedbackUpdated, setIsFeedbackUpdated] = useState(false);
  const [isCompleteError, setIsCompleteError] = useState(false);
  const [users, setUsers] = useState([]);
  const [attendaceData, setAttendaceData] = useState([]);
  const [selectedPU, setSelectedPU] = useState([]);
  const [selectedAU, setSelectedAU] = useState([]);
  const [absentUsers, setAbsentUsers] = useState([]);
  const [selectedActivityFeedbackTypes, setSelectedActivityFeedbackTypes] = useState([{}]);
  const [feedbackUser, setFeedbackUser] = useState({});
  const [feedbackActivityUser, setFeedbackActivityUser] = useState([]);
  const [coachFeedback, setCoachFeedback] = useState({});
  const [coachFeedbackText, setCoachFeedbackText] = useState("");
  const [coachFeedbackTextTemp, setCoachFeedbackTextTemp] = useState("");
  const [offeringUserActivityId, setOfferingUserActivityId] = useState("");
  const [offeringActivityFeedback, setOfferingActivityFeedback] = useState([]);
  const [showSkillTrajectory, setShowSkillTrajectory] = useState(false);
  const [showActionBtn, setShowActionBtn] = useState(true);
  // const [offeringActivityFeedbackTypes, setOfferingActivityFeedbackTypes] =
  useState([]);
  const [buttonLabel, setButtonLabel] = useState("Details");
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const [activityStatus, setActivityStatus] = useState(
    props.item.isComplete
      ? "completed "
      : props.item.isUnlocked
        ? "unlocked"
        : "locked"
  );

  useEffect(() => {
    setCoachFeedbackText(coachFeedbackTextTemp);
    setUpdateSuccess(false);
  }, [showFeedbackForm]);

  const [isArrowUp, setIsArrowUp] = useState(false);
  // let status = props.item.isComplete ? "completed " : props.item.isUnlocked ? "unlocked" : "locked";
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [feedbackSaved, setFeedbackSaved] = useState(true);

  const [feedBackCount, setFeedBackCount] = useState(0);
  const [teamMemberes, setTeamMemberes] = useState([]);

  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  const saveFeedback = () => {
    //if (connectValue !== "" && ownValue !== "" && solveValue !== "" && communicateValue !== "") {
    let data = {
      note: coachFeedbackText,
      feedback: selectedActivityFeedbackTypes,
    };

    messagePoint.activityId = props.item.activityId;
    messagePoint.offeringUserId = feedbackUser.value;
    var requestObject = {
      requestModel: {
        OfferingUserActivityId: offeringUserActivityId,
        Feedback: JSON.stringify(data),
      },
      message: messagePoint,
      isBackgroundJob: false,
    };
    setFeedbackSaved(false);
    UserActivityAxios.put(
      "/OfferingUserActivity/updateactivityfeedback",
      requestObject
    )
      .then(function (response) {
        setFeedbackSaved(true);
        setIsFeedbackUpdated(!isFeedbackUpdated);
        setUpdateSuccess(true);
        setTimeout(() => {
          setUpdateSuccess(false);
        }, 8000);
      })
      .catch(function (error) { });
    //}
  };

  const setTab = (link, stageId, item) => {
    dispatch(appStateSlice.actions.setActiveTab(item));
    dispatch(appStateSlice.actions.setCurrentStage(stageId));
    history.push(link);
  };

  useEffect(() => {
    let actionId = props.item.activityTypeId;
    getLabel(actionId, props.item.isComplete);
  }, [props.item]);

  useEffect(() => {
    if (userDetails.roleId == 5 && props.item.activityTypeId == 5) {
      setShowActionBtn(false);
    }
  }, [userDetails, props.item]);

  useEffect(() => {
    if (
      props.item.isUnlocked &&
      (props.item.activityTypeId === 1 || props.item.activityTypeId === 2)
    ) {
      // if (userDetails.roleId == 5) {
      ProgramSetupAxios.get(
        "/OfferingActivityFeedback/getofferingactivityfeedback/" +
        userDetails.offeringId
      )
        .then(function (response) {
          let data = response.data.sort((a, b) =>
            a.sortOrder > b.sortOrder ? 1 : -1
          );
          let tmp = [];
          data.forEach((element) => {
            tmp.push({
              id: element.id,
              name: element.name,
              feedback: {
                id: "",
                name: "",
                value: 0,
              },
            });
          });
          setSelectedActivityFeedbackTypes(tmp);
          setOfferingActivityFeedback(data);
          setCoachFeedbackText("");

          OnboardingAxios.get(
            "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
          ).then(function (res) {
            if (res.data.length > 0) {
              let teamMemberIds = res.data.map(function (e) { return e.offeringUserId; }).join(',');

              teamMemberIds = teamMemberIds + "," + userDetails.offeringUserId;

              UserActivityAxios.get(
                `/OfferingUserActivity/getactivityfeedbackusers/${props.item.activityId}/${teamMemberIds}`
              )
                .then(function (response) {
                  setUsers(response.data);
                  setFeedbackActivityUser(response.data);
                  let data = response.data;
                  setFeedBackCount(
                    data.filter((x) => x.roleId !== 5 && x.coachFeedback === "")
                      .length
                  );
                  let userList = response.data
                    .filter((x) => x.roleId !== 5)
                    .map((item) => {
                      return {
                        label: item.firstName + " " + item.lastName,
                        value: item.offeringUserId,
                        feedback: item.coachFeedback,
                      };
                    });
                  userList = userList.sort((a, b) => (a.label > b.label ? 1 : -1));
                  setTeamMemberes(userList);
                  let currentUser = {};
                  if (feedbackUser.label == undefined) {
                    currentUser = userList[0];
                    setFeedbackUser(userList[0]);
                  } else {
                    currentUser = userList.filter(
                      (x) => x.value == feedbackUser.value
                    )[0];
                    setFeedbackUser(
                      userList.filter((x) => x.value == feedbackUser.value)[0]
                    );
                  }

                  setOfferingUserActivityId(data.filter((x) => x.offeringUserId == currentUser["value"])[0]["id"]);

                  if (currentUser["feedback"] && currentUser.feedback != "") {
                    let data = JSON.parse(currentUser["feedback"]);
                    setCoachFeedback(data);
                    setSelectedActivityFeedbackTypes(data.feedback);
                    setCoachFeedbackText(data.note);
                    setCoachFeedbackTextTemp(data.note);
                  }

                  UserActivityAxios.get(
                    `OfferingUserActivity/getattendance/${props.item.activityId}/${teamMemberIds}`
                  )
                    .then(function (response) {
                      let data = response.data;
                      data.length > 0 && setIsComplete(data[0].isComplete);
                      if (data) setAttendaceData(data);
                      else setAttendaceData([]);
                    })
                    .catch(function (error) { });

                })
                .catch(function (error) { });
            }
          }).catch(function (error) {
            console.log(error);
          });
        })
        .catch(function (error) { });
      // }
    }
  }, [props.item, isFeedbackUpdated]);

  useEffect(() => {
    let au = attendaceData
      .filter((item) => !item.meetingAttended)
      .map((item) => item.offeringUserId);

    let allUser = [...users];
    let absent = users.filter(function (el) {
      return au.includes(el.offeringUserId);
    });

    allUser = users.filter(function (el) {
      return !au.includes(el.offeringUserId);
    });

    setUsers(allUser);
    setAbsentUsers(absent);
    setSelectedPU([]);
  }, [attendaceData]);

  useEffect(() => {
    setActivityStatus(
      props.item.isComplete
        ? "completed "
        : props.item.isUnlocked
          ? "unlocked"
          : "locked"
    );
  }, [props.item.isUnlocked]);

  const markAttendace = (data, activityId) => {
    messagePoint.activityId = props.item.activityId;
    var requestObject = {
      requestModel: data,
      message: messagePoint,
      isBackgroundJob: false,
    };

    UserActivityAxios.put(
      "/OfferingUserActivity/updatelearnerdata",
      requestObject
    )
      .then(function (response) {
        isComplete && setActivityStatus("completed ");
        setUpdateSuccess(true);
        <Toaster
          show={true}
          title="Success"
          text="Update success."
          variant="success"
          key="update-toast"
        />;
      })
      .catch(function (error) { });
  };

  const updateAttendance = () => {
    setUpdateSuccess(false);
    if (!isComplete) {
      setIsCompleteError(true);
      return;
    } else {
      setIsCompleteError(false);
    }

    let presentAttendance = users.map((item) => {
      return {
        offeringUserId: item.offeringUserId,
        activityId: props.item.activityId,
        activityData: "",
        meetingAttended: true,
        isComplete: isComplete,
        ActivityCompletedBy: userDetails.firstName + " " + userDetails.lastName,
        activityCompletedOn: new Date(),
      };
    });
    let absentAttendance = absentUsers.map((item) => {
      return {
        offeringUserId: item.offeringUserId,
        activityId: props.item.activityId,
        activityData: "",
        meetingAttended: false,
        isComplete: isComplete,
        ActivityCompletedBy: userDetails.firstName + " " + userDetails.lastName,
        activityCompletedOn: new Date(),
      };
    });

    let attendaceData = [...presentAttendance, ...absentAttendance];
    // let attendaceData = [...presentAttendance];

    markAttendace(attendaceData, props.item.activityId);
  };

  const getDateTime = (item) => {
    const date = new Date(item + "Z");
    // let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();

    if (dt < 10) {
      dt = "0" + dt;
    }

    if (month < 10) {
      month = "0" + month;
    }

    const sortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];

    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    // var strTime = hours + ':' + minutes + ' ' + ampm;
    var strTime = hours + " " + ampm;

    return {
      date: dt + " " + sortNames[parseInt(month) - 1],
      time: strTime,
      activityCompletedOn: month + "/" + dt + " at " + hours + ":" + minutes + " " + ampm.toUpperCase(),
    };
  };

  const [skillTrajectoryUnlock, setSkillTrajectoryUnlock] = useState(false);
  const toggleView = (item, isCompleted) => {
    setIsArrowUp(!isArrowUp);
    if (item === 1) {
      if (userDetails.roleId == 5 && isCompleted) {
        setShowFeedbackForm(!showFeedbackForm);
      } else {
        setShowAtendace(!showAtendace);
      }
    } else if (item == 2) {
      setShowAtendace(!showAtendace);
    } else if (item === 3) {
      setTab("/mission/stage", props.item.stageId, "Solve");
    }
    else if (item === 4) {
      setTab("/mission/stage", props.item.stageId, "Submit");
    } else if (item === 5) {
      setSkillTrajectoryUnlock(true);
      UserActivityAxios.get(`UserReflection/${userDetails.offeringId}/${userDetails.email}`)
        .then(function (response) {
          if (
            response.data != null &&
            response.data != "" &&
            response.data != undefined
          ) {
            setShowSkillTrajectory(true);
            setSkillTrajectoryUnlock(false);
            //check if activity is not completed and then 
            /* if (!props.item.isCompleted) {
               messagePoint.activityId = props.item.activityId;
               var data = {
                 offeringUserId: userDetails.offeringUserId,
                 activityId: props.item.activityId,
                 isComplete: true,
                 activityCompletedBy: userDetails.firstName,
                 activityCompletedOn: new Date()
               };
               var requestObject = {
                 requestModel: data,
                 message: messagePoint,
                 isBackgroundJob: false,
               };
               UserActivityAxios.put(
                 "/OfferingUserActivity/submitskilltrajectory",
                 requestObject
               )
                 .then(function (response) {
                   isComplete && setActivityStatus("completed ");
                   <Toaster
                     show={true}
                     title="Success"
                     text="Update success."
                     variant="success"
                     key="update-toast"
                   />;
                 })
                 .catch(function (error) { });
             }*/

          } else {
            let data = {
              offeringId: parseInt(userDetails.offeringId),
              userId: userDetails.email,
              userName: userDetails.firstName + " " + userDetails.lastName,
              lessonStatus: "",
              lessonLocation: "",
              suspendData: "",
              scoreSummary: "",
            };

            UserActivityAxios.post("UserReflection ", data)
              .then(function (response) {
                setShowSkillTrajectory(true);
              })
              .catch(function (error) {
                console.log("error ::: ", error);
              });
          }
        })
        .catch(function (error) {
          skillTrajectoryUnlock(false);
          console.log("error: " + error);
        });
    }
    setUpdateSuccess(false);
  };

  const submitSkillTrajectory = () => {

    UserActivityAxios.get(`UserReflection/${userDetails.offeringId}/${userDetails.email}`)
      .then(function (response) {
        if (
          response.data != null &&
          response.data != "" &&
          response.data != undefined
        ) {

          //check if activity is not completed and then 
          if (activityStatus != "completed " && response.data.lessonStatus != "incomplete") {
            messagePoint.activityId = 0;
            var data = {
              offeringUserId: userDetails.offeringUserId,
              activityId: props.item.activityId,
              email: userDetails.email,
              isComplete: true,
              activityCompletedBy: userDetails.firstName,
              activityCompletedOn: new Date()
            };
            var requestObject = {
              requestModel: data,
              message: messagePoint,
              isBackgroundJob: false,
            };
            UserActivityAxios.put(
              "/OfferingUserActivity/submitskilltrajectory",
              requestObject
            )
              .then(function (response) {
                setActivityStatus("completed ");
                <Toaster
                  show={true}
                  title="Success"
                  text="Update success."
                  variant="success"
                  key="update-toast"
                />;
              })
              .catch(function (error) { });
          }

        } else {
          let data = {
            offeringId: parseInt(userDetails.offeringId),
            userId: userDetails.email,
            userName: userDetails.firstName + " " + userDetails.lastName,
            lessonStatus: "",
            lessonLocation: "",
            suspendData: "",
            scoreSummary: "",
          };

          UserActivityAxios.post("UserReflection ", data)
            .then(function (response) {
              setShowSkillTrajectory(true);
            })
            .catch(function (error) {
              console.log("error ::: ", error);
            });
        }
      })
      .catch(function (error) {
        console.log("error: " + error);
      });
  };



  const getLabel = (item, isCompleted) => {
    if (item == 1) {
      if (userDetails.roleId == 5 && isCompleted)
        setButtonLabel("Provide Feedback");
      else setButtonLabel("Mark Attendance");
    }
    else if (item == 2) {
      setButtonLabel("Mark Attendance");
    }
    else if (item == 4) {
      setButtonLabel("Submit");
      setShowRightArrow(true);
    }
    else if (item == 3) {
      setButtonLabel("Solve");
      setShowRightArrow(true);
    } else if (item == 5) {
      setButtonLabel("Skill Trajectory");
      setShowRightArrow(true);
    }
  };

  const selectPU = (id) => {
    let isExist = selectedPU.includes(id);
    if (isExist) {
      let pu = selectedPU.filter((item) => item !== id);
      setSelectedPU(pu);
    } else setSelectedPU([...selectedPU, id]);
  };

  const selectAU = (id) => {
    let isExist = selectedAU.includes(id);
    if (isExist) {
      let au = selectedAU.filter((item) => item !== id);
      setSelectedAU(au);
    } else setSelectedAU([...selectedAU, id]);
  };

  const absentUser = () => {
    let allUser = [...users];
    let absent = [...absentUsers];
    let u = users.filter(function (el) {
      return selectedPU.includes(el.offeringUserId);
    });
    absent = [...absent, ...u];

    allUser = users.filter(function (el) {
      return !selectedPU.includes(el.offeringUserId);
    });

    setUsers(allUser);
    setAbsentUsers(absent);
    setSelectedPU([]);
  };

  const removeAbsentUser = () => {
    let allUser = [...users];
    let absent = [...absentUsers];
    let u = absentUsers.filter(function (el) {
      return selectedAU.includes(el.offeringUserId);
    });

    allUser = [...allUser, ...u];

    absent = absentUsers.filter(function (el) {
      return !selectedAU.includes(el.offeringUserId);
    });

    setUsers(allUser);
    setAbsentUsers(absent);
    setSelectedAU([]);
  };

  const onTeamMemberChanged = (item) => {
    setFeedbackUser(item);
    let feedbackData = feedbackActivityUser.filter(
      (x) => x.offeringUserId == item.value
    )[0];

    setOfferingUserActivityId(feedbackActivityUser.filter((x) => x.offeringUserId == item["value"])[0]["id"]);

    if (
      feedbackData &&
      feedbackData.coachFeedback &&
      feedbackData.coachFeedback != ""
    ) {
      let data = JSON.parse(feedbackData.coachFeedback);
      setCoachFeedback(data);
      setSelectedActivityFeedbackTypes(data.feedback);
      setCoachFeedbackText(data.note);
      setCoachFeedbackText(data.note);
    } else {
      let tmp = [];
      offeringActivityFeedback.forEach((element) => {
        tmp.push({
          id: element.id,
          name: element.name,
          feedback: {
            id: "",
            name: "",
          },
        });
      });
      setSelectedActivityFeedbackTypes(tmp);
      setCoachFeedbackText("");
    }
  };

  const formatOptionLabel = ({ value, label, feedback }) => (
    <div className="react-select-option" style={{ display: "flex" }}>
      <div>{label}</div>
      <div style={{ marginLeft: "auto" }}>
        {feedback !== "" && <img src={FeedbackComplete} />}
      </div>
    </div>
  );

  const onFeedbackTypeChanged = (item, value) => {
    let feedbackTypesData = [...selectedActivityFeedbackTypes];
    feedbackTypesData.filter((x) => x.id == item.id)[0]["feedback"]["id"] = value;
    feedbackTypesData.filter((x) => x.id == item.id)[0]["feedback"]["name"] =
      item.offeringActivityFeedbackTypes.filter((x) => x.id == value)[0]["name"];
    feedbackTypesData.filter((x) => x.id == item.id)[0]["feedback"]["value"] =
      item.offeringActivityFeedbackTypes.filter((x) => x.id == value)[0]["value"];
    setSelectedActivityFeedbackTypes(feedbackTypesData);
  };

  let active = showAtendace ? "active" : "";

  function IsJsonString(str) {
    try {
      var temp = JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const [popoverData, setPopoverData] = useState("");

  const renderTooltip = (
    <Popover id="popover-basic" className="questions-pop feedback-info-popover">
      <div dangerouslySetInnerHTML={{ __html: popoverData }}></div>
    </Popover>
  );

  return (
    <div className="event-wrapper">
      <div className="event-item">
        <div className="date-holder">
          <div className="date">
            {getDateTime(props.item.activityStartDate).date}
          </div>
          <div className="time">
            {getDateTime(props.item.activityStartDate).time}{" "}
            {props.item.timezone}
          </div>

          <div className={"event-status " + activityStatus}></div>
        </div>
        <div className="content-holder">
          <div className="event-content">{props.item.activityName}</div>
          {!props.hideAction && (
            <div className="action">
              {props.item.activityTypeId !== 0 && showActionBtn && (
                <Button
                  disabled={!props.item.isUnlocked || skillTrajectoryUnlock ? true : false}
                  className={
                    "event-action d-flex justify-content-between " + active
                  }
                  onClick={() =>
                    toggleView(
                      props.item.activityTypeId,
                      props.item.isComplete
                    )
                  }
                >
                  <label className="btn-icon"></label>
                  <label>{buttonLabel}</label>
                  <label
                    className={
                      showRightArrow ? "btn-icon transform90" : (isArrowUp ? "btn-icon transform180" : "btn-icon")
                    }
                  >
                    <img
                      className="ml-3"
                      alt=""
                      src="../space/img/caretDownFill.svg"
                    />
                  </label>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>

      {props.item.longDescription && (
        <div className="event-description">
          {IsJsonString(props.item.longDescription) &&
            Array.isArray(JSON.parse(props.item.longDescription)) ? (
            JSON.parse(props.item.longDescription).map((desc, index) => {
              return (
                <div className="desc-item" key={"task-" + index}>
                  <div className="inactive"></div>
                  {desc.text}
                </div>
              );
            })
          ) : (
            <div className="desc-item">
              <div className="inactive"></div>
              {props.item.longDescription}
            </div>
          )}
        </div>
      )}

      {showAtendace && (
        <div className="attendace ">
          <div className="row">
            <div className="col">
              <h4 className="heading-title">Present</h4>
              <ul className="users-list">
                {users
                  .sort((a, b) => (a.firstName > b.firstName ? 1 : -1))
                  .map((item, index) => {
                    let isSelected = selectedPU.includes(item.offeringUserId)
                      ? " selected"
                      : "";
                    return (
                      <>
                        {
                          item.roleId == 4 && <li key={`asdasd${index}`}
                            className={"item" + isSelected}
                            onClick={() => selectPU(item.offeringUserId)}
                          >
                            {item.firstName + " " + item.lastName}
                          </li>

                        }
                      </>
                    );
                  })}
              </ul>
            </div>
            <div className="col-2 select-arrow">
              <div
                className="select-arrow-btn"
                onClick={() => absentUser()}
              ></div>
              <div
                className="select-arrow-btn select-flip"
                onClick={() => removeAbsentUser()}
              ></div>
            </div>
            <div className="col">
              <h4 className="heading-title">Absent</h4>
              <ul className="users-list">
                {absentUsers
                  .sort((a, b) => (a.firstName > b.firstName ? 1 : -1))
                  .map((item, index) => {
                    let isSelected = selectedAU.includes(item.offeringUserId)
                      ? " selected"
                      : "";
                    return (
                      <li key={`qasfx${index}`}
                        className={"item" + isSelected}
                        onClick={() => selectAU(item.offeringUserId)}
                      >
                        {item.firstName + " " + item.lastName}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="event-footer">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <Checkbox
                className="me-4"
                label="Mark as complete"
                checked={isComplete}
                onChange={(e) => setIsComplete(e.target.checked)}
              />
              <span className="attendace-by">
                {attendaceData.length > 0 &&
                  attendaceData[0].activityCompletedBy &&
                  "Last saved by " +
                  attendaceData[0].activityCompletedBy +
                  " on " +
                  getDateTime(attendaceData[0].activityCompletedOn).activityCompletedOn}
              </span>
            </div>
            <div className="d-flex">
              <Button className="mr-2" onClick={(item) => updateAttendance()}>
                Save
              </Button>
              <Button
                onClick={() => {
                  setShowAtendace(!showAtendace);
                  setIsArrowUp(!isArrowUp);
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
          <div className="text-right">
            {isCompleteError && (
              <div className="error-message">Select Mark as complete.</div>
            )}
            {updateSuccess && (
              <div className="success-message">Updated successfully.</div>
            )}
          </div>
        </div>
      )
      }

      {
        showFeedbackForm && (
          <div className="coach-feedback">
            <div className="row mlr-0">
              <div className="col-12 feedback-section-text">
                <p>
                  Based on the first team huddle and individual assignments,
                  please rate your team members on Connect, Own, Solve, and
                  Communicate. Please include constructive feedback to help them
                  know what they’re doing well and how they might be able to
                  improve.
                </p>
                <p>
                  Note: If you haven’t yet had an opportunity to see a particular
                  value in action, please select 5 for the purpose of this survey.
                </p>
              </div>
            </div>
            <div className="row mlr-0 coach-feedback-select">
              <div className="col-12 pl-0">
                <div className="feedback-user-dopdown">
                  {/* <select className="cdx-feedback-input" onChange={onTeamMemberChanged}>
                                {teamMemberes && teamMemberes.map(item => {
                                    return <option value={item.value} key={"option-" + item.value} className="completed">{item.label}</option>
                                })}
                            </select> */}
                  <Select
                    className="select-plugin"
                    value={feedbackUser}
                    onChange={onTeamMemberChanged}
                    options={teamMemberes}
                    formatOptionLabel={formatOptionLabel}
                  />
                </div>
                <div className="pending-feedback">
                  {feedBackCount} Pending Feedback
                </div>
              </div>
            </div>
            <div className="row mtb-10 mlr-0 coach-feedback-bottom-section pt-3">
              {offeringActivityFeedback &&
                offeringActivityFeedback.map((item, index) => {
                  return (
                    <>
                      <div
                        className={`col-3 feedback-${index + 1}-div-col`}
                        key={"feedbackOption" + item.id}
                      >
                        <div className={`feedback-${index + 1}-div`}>
                          <div className="feedback-block-header">
                            {item.name.length > 10 && window.innerWidth >= 1280 && window.innerWidth <= 1380 &&
                              <span title={item.name}>{item.name.substring(0, 5)}...</span>}
                            {item.name.length > 10 && window.innerWidth >= 1380 && window.innerWidth <= 1440 &&
                              <span title={item.name}>{item.name.substring(0, 8)}...</span>}
                            {item.name.length > 10 && window.innerWidth > 1440 &&
                              <span title={item.name}>{item.name}</span>}
                            {item.name.length < 10 &&
                              <span title={item.name}>{item.name}</span>}
                            <OverlayTrigger
                              placement="top"
                              trigger={["hover", "focus"]}
                              overlay={renderTooltip}
                              rootClose
                            >
                              <span onMouseEnter={() => { setPopoverData(item.description); }} className="feedback-info-icon"></span>
                            </OverlayTrigger>
                          </div>
                          <div className="cdx-input">
                            {item && item.offeringActivityFeedbackTypes && (
                              <select
                                value={
                                  selectedActivityFeedbackTypes &&
                                  selectedActivityFeedbackTypes.filter((x) => x.id == item.id)[0]["feedback"]["id"]}
                                onChange={(v) => {
                                  onFeedbackTypeChanged(
                                    item,
                                    v.currentTarget.value
                                  );
                                }}
                              >
                                <option value="" disabled>
                                  -Select Rating-
                                </option>
                                {item.offeringActivityFeedbackTypes &&
                                  item.offeringActivityFeedbackTypes.sort((a, b) => { return a.sortOrder - b.sortOrder; }).map(
                                    (childItem) => {
                                      return (
                                        <option
                                          value={childItem.id}
                                          key={"option-" + childItem.id}
                                        >
                                          {childItem.name}
                                        </option>
                                      );
                                    }
                                  )}
                              </select>
                            )}
                            {/* {item.name === "Connect" && <SelectDropdown placeholder="-Select Rating-" options={connectOptions} className="col-md" value={connectValue} onChange={(v) => { setConnectValue(v.currentTarget.value) }} />}
                                            {item.name === "Own" && <SelectDropdown placeholder="-Select Rating-" options={ownOptions} className="col-md" value={ownValue} onChange={(v) => { setOwnValue(v.currentTarget.value) }} />}
                                            {item.name === "Solve" && <SelectDropdown placeholder="-Select Rating-" options={solveOptions} className="col-md" value={solveValue} onChange={(v) => { setSolveValue(v.currentTarget.value) }} />}
                                            {item.name === "Communicate" && <SelectDropdown placeholder="-Select Rating-" options={communicateOptions} className="col-md" value={communicateValue} onChange={(v) => { setCommunicateValue(v.currentTarget.value) }} />} */}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}

              <div className="col-12">
                <TextAreaInput
                  placeholder="Additional Feedback"
                  className="coach-feedback-input"
                  rows="4"
                  value={coachFeedbackText}
                  onChange={(item) => {
                    setCoachFeedbackText(item.currentTarget.value);
                  }}
                  maxLength="500"
                />
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-end">
                  <div className="d-flex">
                    {feedbackSaved && selectedActivityFeedbackTypes.filter(x => x.feedback && x.feedback.id == "").length > 0 &&
                      <Button className="mr-2" disabled>
                        Save
                      </Button>}
                    {feedbackSaved && selectedActivityFeedbackTypes.filter(x => x.feedback && x.feedback.id == "").length == 0 &&
                      <Button className="mr-2" onClick={() => saveFeedback()}>
                        Save
                      </Button>}
                    {!feedbackSaved &&
                      <Button className="mr-2">
                        Save
                      </Button>}
                    <Button
                      onClick={() => {
                        setShowFeedbackForm(!showFeedbackForm);
                        setIsArrowUp(!isArrowUp);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
                <div className="text-right">
                  {isCompleteError && (
                    <div className="error-message">Select Mark as complete.</div>
                  )}
                  {updateSuccess && (
                    <div className="success-message">Updated successfully.</div>
                  )}
                </div>
              </div>
            </div>


          </div>
        )
      }

      <CdxModal
        show={showSkillTrajectory}
        onHide={() => {
          setShowSkillTrajectory(false);
        }}
        onClose={() => {
          setShowSkillTrajectory(false);
        }}
        backdrop="static"
        keyboard={false}
        fullscreen={true}
        className="info-model skill-trajectory-model"
      >
        <CdxModal.Header>
          <div className="branding">
            <div className="logo-image"> </div>
            <div className="logo-text"></div>
          </div>
          <div
            className="modal-close-btn"
            onClick={() => {
              setShowSkillTrajectory(false); submitSkillTrajectory();
            }}
          ></div>
        </CdxModal.Header>
        <CdxModal.Body>
          < SkillTrajectory
            closeSkillTrajectory={() => { setShowSkillTrajectory(false); submitSkillTrajectory(); }}
            offeringId={parseInt(userDetails.offeringId)}
            email={userDetails.email}
            showSkillTrajectory={showSkillTrajectory}
          />
        </CdxModal.Body>

      </CdxModal>

    </div >
  );
};

export default EventItem;
